import { ReactNode } from 'react';

import './ModalContentMain.scss';

export type ModalContentMainProps = {
    children?: ReactNode;
};

export const ModalContentMain = (props: ModalContentMainProps) => {
    const { children } = props;

    return <article className="modal-content-main">{children}</article>;
};
